<div [formGroup]="form">
  <label class="control control--radio" *ngFor="let opt of field.Answers; let j = index" [ngClass]="{'control--vertical' : field.QuestionRender == 'Vertical' }">
    <input type="radio" [formControlName]="field.uniquename" id="option_{{opt.FormAnswerID}}" [value]="opt.FormAnswerID" /> <!--  @Model.DisabledHTML-->
    <span class="control__indicator"
          [ngClass]="{'input-validation-error': isTouched && isInValid }"></span>
    <span>{{opt.Answer}}</span>
  </label>
</div>
